import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, Divider, TextField } from '@material-ui/core';
import { Delete, ExpandLess, ExpandMore, UnfoldMore } from '@material-ui/icons';
import { useEffect, useState } from 'react';

export const EmailControl = ({ onUpdate, value, onDelete, isSelected }) => {
    const [displayLabel, setdisplayLabel] = useState("");
    const [email, setEmail] = useState("");
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        try {
            let val = JSON.parse(value);
            setEmail(val.email);
            setdisplayLabel(val.displayLabel);
        }
        catch { }
    }, [value]);

    useEffect(() => {
        setExpanded(isSelected);
    }, [isSelected])

    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={expanded}>
                <AccordionSummary
                    className='handle'
                    expandIcon={
                        expanded ?
                            <ExpandLess onClick={() => setExpanded(!expanded)} /> :
                            <ExpandMore onClick={() => setExpanded(!expanded)} />
                    }
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;
                            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 4.11133L8.8906 9.37173C9.5624 9.81959 10.4376 9.81959 11.1094 9.37173L19 4.11133M3 15.1113H17C18.1046 15.1113 19 14.2159 19 13.1113V3.11133C19 2.00676 18.1046 1.11133 17 1.11133H3C1.89543 1.11133 1 2.00676 1 3.11133V13.1113C1 14.2159 1.89543 15.1113 3 15.1113Z" stroke={"#CECECE"} stroke-width="1.26316" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Email
                        </div>
                    </Box>

                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <div className='w-full'>
                        <TextField
                            placeholder='Label'
                            label="Label"
                            onChange={(e) => {
                                setdisplayLabel(e.target.value);
                                onUpdate(
                                    JSON.stringify({
                                        displayLabel: e.target.value,
                                        email: email
                                    }));
                            }}
                            variant='outlined'
                            fullWidth
                            className='my-2'
                            margin="dense"
                            value={displayLabel}
                        />
                        <TextField
                            placeholder='Email Address'
                            label='Email Address'
                            onChange={(e) => {

                                setEmail(e.target.value)
                                onUpdate(
                                    JSON.stringify({
                                        displayLabel: displayLabel,
                                        email: e.target.value
                                    }));
                            }}
                            variant='outlined'
                            type={"email"}
                            fullWidth
                            margin="dense"
                            className='my-2'
                            value={email}
                        />
                    </div>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        className="ml-0"
                        startIcon={<Delete />}
                        onClick={() => {
                            setExpanded(false);
                            setEmail("");
                            setdisplayLabel("");
                            onDelete();
                        }} fullWidth
                        variant='contained' color="default">
                        Remove
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}
